/**
 * Hide app-generated tabs that don't have native disable settings
 */
const hideAppTabs = () => {
  const ids = [
    '#tab-ref-add_layer',
    '#tab-ref-load_saved',
    '#tab-ref-save_data',
  ];

  ids.forEach(selector => {
    const el = document.querySelector(selector);
    if (el instanceof HTMLElement) {
      el.style.setProperty('display', 'none', 'important');
    }
  });
};

// Run on load
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', hideAppTabs);
} else {
  // DOM already loaded
  hideAppTabs();
}

// Watch for dynamic DOM changes
const observer = new MutationObserver(hideAppTabs);
observer.observe(document.body, { 
  childList: true, 
  subtree: true 
});
